<template>
    <el-dialog :title="title" :visible.sync="visible" width="500px" :close-on-click-modal="false">
        <Language :add="add" v-model="form.lang" style="margin-top: -20px" @change="handleLangChange"></Language>
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <el-form-item label="分类名称" prop="name">
                <el-input v-model="form.name" placeholder="请输入分类名称"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="visible = false">取消</el-button>
            <el-button type="primary" @click="handleConfirm">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import Language from "@/components/Language";
import { getUuid } from "@/jslibs/utils";
import { add, edit, detail } from "@/api/case/category";
export default {
    components: { Language },
    data() {
        return {
            visible: false,
            title: "新增分类",
            form: {
                name: "",
            },
            rules: {
                name: [{ required: true, message: "请输入分类名称" }],
            },
            cuuid: "",
            uuid: "",
			add: true,
        };
    },
    methods: {
        open(row) {
            this.visible = true;
            if (row) {
				this.add = false;
                this.title = "编辑分类";
                this.form.name = row.name;
                this.form.lang = "zh";
                this.form.cuuid = row.cuuid;
                this.cuuid = row.cuuid;
                this.uuid = row.uuid;
            } else {
				this.add = true;
                this.title = "新增分类";
                this.form.name = "";
                this.form.lang = "zh";
                this.form.cuuid = getUuid();
                this.uuid = "";
                this.$nextTick(() => {
                    this.$refs.form.clearValidate();
                });
            }
        },
        handleLangChange() {
            this.getDetail();
        },
        getDetail() {
            detail({ cuuid: this.form.cuuid, lang: this.form.lang }).then(({ code, result, error }) => {
                if (code === 200) {
                    if (result) {
                        this.form.name = result.name;
                        this.form.cuuid = result.cuuid;
                        this.cuuid = this.form.cuuid;
                        this.uuid = result.uuid;
                    } else {
                        this.form.name = "";
                        this.$nextTick(() => {
                            this.$refs.form.clearValidate();
                        });
                        this.cuuid = "";
                    }
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                const params = {
                    ...this.form,
                };
                if (this.uuid) {
                    if (!this.cuuid) {
                        add(params).then(({ code, error }) => {
                            if (code === 200) {
                                this.$message.success("新增成功");
								this.visible = false;
                                this.$emit("update");
                            } else {
                                this.$message.error(error.message);
                            }
                        });
                    } else {
                        params.uuid = this.uuid;
                        edit(params).then(({ code, error }) => {
                            if (code === 200) {
                                this.$message.success("编辑成功");
								this.visible = false;
                                this.$emit("update");
                            } else {
                                this.$message.error(error.message);
                            }
                        });
                    }
                } else {
                    add(params).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("新增成功");
							this.visible = false;
                            this.$emit("update");
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                }
            });
        },
    },
};
</script>

<style></style>
